import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { VatCorrectionsScheme } from 'redux/reducers/vatCorrections/constants';
import { EU_NOTICE, GB_NOTICE } from '../constants';
import { TNoticeProps } from './types';

export const Notice: FC<TNoticeProps> = ({ typeOfReport }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				backgroundColor: '#0092de24',
				borderRadius: '12px',
				p: '20px',
				mt: '20px',
				width: 'calc(100% - 40px)',
			}}
		>
			<Typography
				sx={{
					fontSize: '3rem',
					color: '#016193',
					fontFamily: 'monospace',
					mr: 2,
					mt: -1,
					fontWeight: 'bold',
					textTransform: 'lowercase',
				}}
			>
				i
			</Typography>
			<Typography sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193' }}>
				{typeOfReport === VatCorrectionsScheme.NON_EU_IMPORT ? GB_NOTICE : EU_NOTICE}
			</Typography>
		</Box>
	);
};
